/**
 * From a problem `code` to the sentence the search box shows.
 *
 * Two lines, because a search has one verb. `validation_failed` is the over-long query — the
 * server's message deliberately does not echo the text (§6), so the sentence is ours.
 * Everything else — a `500`, a dropped connection, a `cursor_invalid` after the query moved on —
 * is "try again", which is also the whole fix.
 */

import { ApiError } from '@/api/client';
import type { Problem } from '@/api/client';
import type { MessageKeys } from '@/lib/i18n';

type Key = MessageKeys['search'];

/** Codes from `ErrorCode` in `backend/src/kalqa/core/errors.py`. TWIN: that enum. */
const BY_CODE: Readonly<Record<string, Key>> = {
  validation_failed: 'error.tooLong',
};

export function searchProblemKey(problem: Problem): Key {
  return BY_CODE[problem.code] ?? 'error.load';
}

export function searchErrorKey(error: unknown): Key {
  return error instanceof ApiError ? searchProblemKey(error.problem) : 'error.load';
}
